import { trackError } from '@billy/track-error'
import { useCallback, useState } from 'react'

import { toggleSetItem } from '../../../utils/toggleSetItem'

const STORAGE_KEY = 'dms-folder-tree-expanded-ids'

function readFromSession(): Set<string> {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    return raw ? new Set(JSON.parse(raw)) : new Set()
  } catch {
    return new Set()
  }
}

function writeToSession(ids: Set<string>): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]))
  } catch (error) {
    trackError(error)
  }
}

export const useExpandedFolders = () => {
  const [expandedIds, setExpandedIds] = useState<Set<string>>(readFromSession)

  const handleToggle = useCallback((id: string) => {
    setExpandedIds((prev) => {
      const next = toggleSetItem(prev, id)
      writeToSession(next)
      return next
    })
  }, [])

  return { expandedIds, handleToggle }
}
